// Facebook Pixel event helpers
// Dataset ID: 1477817796730695

export const fbq = (...args) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq(...args);
  }
};

// Track when someone views the register page (Lead intent)
export const trackViewContent = (contentName) => {
  fbq('track', 'ViewContent', { content_name: contentName });
};

// Track when someone starts filling out the registration form
export const trackLead = (data = {}) => {
  fbq('track', 'Lead', {
    content_name: 'Full Arch ROI Registration',
    ...data,
  });
};

// Track when OTP is verified and registration is complete
export const trackCompleteRegistration = (data = {}) => {
  fbq('track', 'CompleteRegistration', {
    content_name: 'Full Arch ROI',
    status: 'completed',
    ...data,
  });
};

// Track when someone lands on checkout success (subscription started)
export const trackSubscribe = (value = 249, currency = 'USD') => {
  fbq('track', 'Subscribe', {
    value,
    currency,
    predicted_ltv: value * 12,
  });
};

// Track purchase/payment completed
export const trackPurchase = (value = 249, currency = 'USD') => {
  fbq('track', 'Purchase', {
    value,
    currency,
    content_name: 'Full Arch ROI Subscription',
    content_type: 'product',
  });
};

// Track initiate checkout
export const trackInitiateCheckout = () => {
  fbq('track', 'InitiateCheckout', {
    value: 249,
    currency: 'USD',
    content_name: 'Full Arch ROI Subscription',
  });
};
